import React, { useEffect, useState, ReactNode, ReactNodeArray } from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, BottoneAPI, Trad, Tipo } from '../components';
import { DocumentList } from '../components/custom/Document/DocumentBox/DocumentList';
import useReducerOnChange from '../hooks/ReducerOnChange';
import ChiamaWeb, { CChiamaWebParametri } from '../ChiamaWeb';

class CSearchParams {
    public GroupName: string = '';
    public OriginalFileName: string = '';
    public FileType: string = '';

    Dati?: Dati.CRisAPIListaDocumenti;
}

export const DocumentsList: React.FC<Glob.IRouteGlobaleProps> = (props) => {
    const [SearchParams, setSearchParams] = useReducerOnChange<CSearchParams>(new CSearchParams());
    const [IsLoading, setIsLoading] = useState(false);

    let FileType: Dati.TDictTipo = {};
    FileType['application/doc'] = new Dati.CTipo('application/doc', 'doc');
    FileType['application/pdf'] = new Dati.CTipo('application/pdf', 'pdf');

    const [GroupFiles, setGroupFiles] = useState<{ [GF: string]: Dati.CDocument[] }>({});

    //const Files: any = [
    //    {MIME: "application/doc", DownloadFileName: "FARMACIA SAN ROCCO SNC_Schema Polizza_All. 2.5.doc", ID_Document: 12159},
    //    {MIME: "application/pdf", DownloadFileName: "D'AGOSTINO ROSA_Visura Catastale 2019.03.07. Messina.pdf", ID_Document: 11335},
    //    {MIME: "application/doc", DownloadFileName: "FARMACIA SAN ROCCO SNC_Schema Polizza_All. 2.5.doc", ID_Document: 12159},
    //    {MIME: "application/pdf", DownloadFileName: "D'AGOSTINO ROSA_Visura Catastale 2019.03.07. Messina.pdf", ID_Document: 11335}
    //];

    function PrintDocumentList(): ReactNodeArray {
        let R: ReactNodeArray = [];
        for (let G in GroupFiles) {
            R.push(<div key={G}>
                <div className="kt-widget4__item bg-secondary border-0 rounded">
                    <div className="kt-font-bold">{G}</div>
                </div>
                <DocumentList Files={JSON.stringify(GroupFiles[G])} OnRemove={() => { }} OnDownloadFile={() => { }} AddEnabled={false} URLDownload="/api/DocumentsList/Download" />
            </div>
            )
        }
        return R;
    }

    function CaricaLista(): void {
        const Param: CChiamaWebParametri = {
            URL: "/api/DocumentsList/List",
            ParamURLClasse: SearchParams,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPILista<Dati.CDocument>) => {
                let GF: { [GF: string]: Dati.CDocument[] } = {};
                for (let I = 0; I < dati.Dati.length; I++) {
                    if (GF[dati.Dati[I].GroupName] == undefined) {
                        GF[dati.Dati[I].GroupName] = [];
                    }
                    GF[dati.Dati[I].GroupName].push(dati.Dati[I]);
                }
                setGroupFiles(GF);
            }
        }
        new ChiamaWeb().Chiama(Param);
    }

    useEffect(() => {
        CaricaLista();
    }, []);

    return (
        <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-file-alt" />
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Documenti")}
                        </h3>
                    </div>
                </div>
            </div>
            <div className="kt-portlet__body">
                <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Compagnia")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input value={SearchParams.GroupName} id="GroupName" onChange={(e) => { setSearchParams({ Type: "OnChangeFromForm", Target: e.currentTarget }) }} type="text" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("NomeFile")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input value={SearchParams.OriginalFileName} id="OriginalFileName" onChange={(e) => { setSearchParams({ Type: "OnChangeFromForm", Target: e.currentTarget }) }} type="text" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("TipoFile")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <Tipo
                                Campo="FileType"
                                ID_ChiaveString={SearchParams.FileType}
                                OnAggiorna={(e, v) => { setSearchParams({ Type: "OnChangeFromValue", Name: e, Value: v }) }}
                                TradValori={false}
                                Dati={FileType}
                            />
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                            <div className="row">
                                <div className="col-lg-12 kt-form__actions kt-form__actions--center">
                                    <Bottone Default Attesa={IsLoading} OnClick={() => { CaricaLista(); }} Testo={Trad.Trad("Cerca")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="kt-widget4">
                    {PrintDocumentList()}
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/form/DocumentsList.tsx